const ARCHIVE_NS = 'http://www.profium.com/archive/';
const RDF_NS = 'http://www.w3.org/2000/01/rdf-schema#';
const XSD_NS = 'http://www.w3.org/2001/XMLSchema#';
const CITY_NS = 'http://www.profium.com/city/';
const PROFIUM_NS = 'http://www.profium.com/schema/v5/';
const SPECTRUM_NS = 'http://www.profium.com/spectrum/';
const IMAGEARCHIVE_NS = 'http://www.profium.com/imagearchive/2007/';
const CE_NS = 'http://www.profium.com/spectrum/ce/';

const Types = {
  RDF : {
    NS: RDF_NS,
    RESOURCE: RDF_NS + 'Resource'
  },

  ARCHIVE : {
    NS: ARCHIVE_NS,
    MODIFIABLE_ENUMERATION: ARCHIVE_NS + 'ModifiableEnumeration',
    IMAGE: ARCHIVE_NS + 'Image',
    DOCUMENT: ARCHIVE_NS + 'Document',
    SEARCH_LINK : ARCHIVE_NS + 'searchLink',
  },

  XSD : {
    NS: XSD_NS,
    DATE: XSD_NS + 'date',
    DATETIME: XSD_NS + 'dateTime',
    STRING: XSD_NS + 'string',
    BOOLEAN: XSD_NS + 'boolean',
    INT: XSD_NS + 'int',
    INTEGER: XSD_NS + 'integer',
    DOUBLE: XSD_NS + 'double',
    DECIMAL: XSD_NS + 'decimal'
  },

  PROFIUM : {
    NS: PROFIUM_NS,
    LONGSTRING: PROFIUM_NS + 'longString',
    ENUMERATION: PROFIUM_NS + 'Enumeration',
    POINT: PROFIUM_NS + 'point',
    POLYGON: PROFIUM_NS + 'polygon',
    LINESTRING: PROFIUM_NS + 'lineString'
  },

  CITY: {
    NS: CITY_NS,
    ASIASANA: CITY_NS + 'asiasana'
  },

  IMAGEARCHIVE: {
    NS: IMAGEARCHIVE_NS,
    CATEGORY: IMAGEARCHIVE_NS + 'Category'
  },

  SPECTRUM: {
    NS: SPECTRUM_NS,
    TARGET_TYPE: SPECTRUM_NS + 'TargetType',
    ACQUISITION_TARGET_TYPE: SPECTRUM_NS + 'AcquisitionTargetTypeList',
    RELATED_OBJECT: SPECTRUM_NS + 'RelatedObject',
    GEOMETRY: SPECTRUM_NS + 'Geometry',
    PLACE_COORDINATES: SPECTRUM_NS + 'PlaceCoordinates',
    PLACE_INFORMATION: SPECTRUM_NS + 'PlaceInformation',
    ACTOR_VIEW: 'Actor',
    LOCATION_INFORMATION_VIEW: 'LocationInformation',
    CE: {
      NS: CE_NS,
      BUILDING_VIEW: 'Building',
      PROPERTY_VIEW: 'Property',
      SUB_SITE: CE_NS + 'SubSite'
    }
  }
};

export default Types;

export const SPECTRUM = Types.SPECTRUM;
export const ARCHIVE = Types.ARCHIVE;

export const isLiteral = type => type.startsWith(Types.XSD.NS) || type.startsWith(Types.PROFIUM.NS);